import React, { ReactElement } from "react";
import { Table } from "antd";
import { rowClassName } from "..";
import { XtdByPubRecord } from "../../../redux/types/reportTypes";
import "./index.scss";

export const columns = [
  {
    title: "Cluster",
    dataIndex: "cluster",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Pub ID",
    dataIndex: "publisher",
  },
  {
    title: "AM",
    dataIndex: "manager",
  },
  {
    title: "Origami",
    dataIndex: "origami",
  },
  {
    title: "Freq",
    dataIndex: "frequency",
  },
  {
    title: "LWTD",
    dataIndex: "lwtd",
  },
  {
    title: "WTD",
    dataIndex: "wtd",
  },
  {
    title: "WTD DIFF",
    dataIndex: "wtd_diff",
  },
  {
    title: "WTD % DIFF",
    dataIndex: "wtd_perc_diff",
  },
  {
    title: "LMTD",
    dataIndex: "lmtd",
  },
  {
    title: "MTD",
    dataIndex: "mtd",
  },
  {
    title: "MTD DIFF",
    dataIndex: "mtd_diff",
  },
  {
    title: "MTD % DIFF",
    dataIndex: "mtd_perc_diff",
  },
  {
    title: "LQTD",
    dataIndex: "lqtd",
  },
  {
    title: "QTD",
    dataIndex: "qtd",
  },
  {
    title: "QTD DIFF",
    dataIndex: "qtd_diff",
  },
  {
    title: "QTD % DIFF",
    dataIndex: "qtd_perc_diff",
  },
];

type ProductTableProps = {
  loading: boolean;
  records: Array<XtdByPubRecord>;
};

type Keys =
  | "lwtd"
  | "wtd"
  | "wtd_diff"
  | "wtd_perc_diff"
  | "lmtd"
  | "mtd"
  | "mtd_diff"
  | "mtd_perc_diff"
  | "lqtd"
  | "qtd"
  | "qtd_diff"
  | "qtd_perc_diff";

const ProductTable = ({ loading, records }: ProductTableProps): ReactElement => {
  const sum = (key: Keys) =>
    records.reduce((a, b) => a + (parseFloat(String(b[key])) || 0), 0);

  const calculateResultRow = () => {
    const result: XtdByPubRecord = {
      cluster: "",
      name: "",
      publisher: 0,
      manager: "",
      origami: "",
      frequency: "",
      lwtd: 0,
      wtd: 0,
      wtd_diff: 0,
      wtd_perc_diff: 0,
      lmtd: 0,
      mtd: 0,
      mtd_diff: 0,
      mtd_perc_diff: 0,
      lqtd: 0,
      qtd: 0,
      qtd_diff: 0,
      qtd_perc_diff: 0,
    };

    Object.keys(records[0]).forEach((key) => {
      const ignoreKeys = [
        "cluster",
        "name",
        "publisher",
        "manager",
        "origami",
        "frequency",
      ];
      if (!ignoreKeys.includes(key)) {
        const newKey = key as Keys;
        result[newKey] = sum(newKey);
      }
    });

    return result;
  };

  const totalRecords = () => {
    const newRecords = [...records];
    if (newRecords.length) newRecords.push(calculateResultRow());
    return newRecords;
  };

  return (
    <Table
      className="partner-table"
      dataSource={totalRecords()}
      columns={columns}
      loading={loading}
      rowKey="publisher"
      pagination={false}
      scroll={{ y: 250 }}
      size="small"
      rowClassName={rowClassName}
    />
  );
};

export default ProductTable;
